import { useLocation } from 'react-router-dom'

import Rueckfragen from '../komponenten/Rueckfragen'

/**
 * Alle Fragen, die das System gerade hat - ueber alle Importe hinweg. Der eine Ort, an dem
 * Frau Barth morgens nachsieht, was von ihr gebraucht wird.
 *
 * Darunter (02.11.2026) die Fragen, die beim Buchen ihres Laufs noch offen waren: nicht mehr offen,
 * aber eine Antwort lässt sich nachtragen. Ein Link mit `#uebergangen` (von „Heute“ oder aus der
 * Freigabe) stellt sie nach oben - sie laden nach den offenen, ein Sprung dorthin träfe daneben.
 */
export default function RueckfragenSeite() {
  const { hash } = useLocation()
  const uebergangenZuerst = hash === '#uebergangen'
  const uebergangen = (
    <div id="uebergangen" key="uebergangen">
      <Rueckfragen status="uebergangen" titel="Beim Buchen übergangen" />
    </div>
  )
  return (
    <>
      <h2>Rückfragen</h2>
      <p className="hinweis" style={{ maxWidth: '70ch' }}>
        Wenn ein Dokument nicht zu dem passt, was das System kennt - eine unbekannte Artikelnummer,
        eine fehlende Umrechnung, ein Bericht in ungewohnter Form -, steht die Frage hier. Antworten
        Sie so, wie Sie es einer Kollegin sagen würden. Das System macht daraus einen Vorschlag;
        erst „Vorschlag anwenden“ ändert etwas.
      </p>
      {uebergangenZuerst && uebergangen}
      <Rueckfragen />
      {!uebergangenZuerst && uebergangen}
    </>
  )
}
